import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useMemo } from 'react';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { AssociatedObjectsCardContext } from '../../context/AssociatedObjectsCardContext';
import { useAssociatedObjectsCardDataContext } from '../../context/AssociatedObjectsCardDataContext';
import AssociatedObjectsCardActions from '../AssociatedObjectsCardActions';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSkeleton = styled.div.withConfig({
  displayName: "AssociatedObjectsCardActionsSdkDataProvider__ActionSkeleton",
  componentId: "lkbxp4-0"
})(["", ""], ({
  theme
}) => `
    background-color: ${theme.color['fill-tertiary-default']};
    background-size: 1200;
    height: 20px;
    width: 50px;
    border-radius: ${theme.borderRadius['100']};
  `);
function AssociatedObjectsCardActionsSdkDataProvider({
  cardId,
  hasScope,
  isUngated,
  objectId,
  objectTypeId,
  propertyNames,
  sortConfiguration,
  readOnly,
  toObjectTypeId,
  propertySource
}) {
  const propertySourceInfo = useMemo(() => {
    return {
      propertySource
    };
  }, [propertySource]);
  // TODO: replace isEmbedded with real info from crm-sdk once they are ready to provide it
  const isEmbedded = false;
  const sendUpdateObject = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT);
  const sendObjectCreated = useSendCrmMessageTopic(TOPIC_NAMES.OBJECT_CREATED);
  const sendUpdateAssociation = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS);
  const onObjectUpdate = useCallback(({
    properties
  }) => {
    sendUpdateObject({
      propertyNames: properties.map((_val, key) => key).toArray(),
      objectTypeId,
      objectId: String(objectId)
    });
  }, [objectId, objectTypeId, sendUpdateObject]);
  const onAssociationUpdate = useCallback(({
    objectId: updatedObjectId,
    objectType: updatedObjectType,
    associationObjectType
  }) => {
    sendUpdateAssociation({
      objectId: String(updatedObjectId),
      objectTypeId: normalizeTypeId(updatedObjectType),
      toObjectTypeId: normalizeTypeId(associationObjectType)
    });
  }, [sendUpdateAssociation]);
  const onObjectCreate = useCallback(({
    associationType,
    objectId: createdObjectId,
    addAnother
  }) => {
    sendObjectCreated({
      objectId: String(createdObjectId),
      objectTypeId: normalizeTypeId(associationType),
      preventRedirect: !!addAnother
    });
  }, [sendObjectCreated]);
  const {
    associationsData,
    associationTypesData,
    objectTypePermissions,
    primaryDisplayLabel,
    refetchAssociationsData,
    userPermissions,
    isLoading
  } = useAssociatedObjectsCardDataContext();
  const contextValue = useMemo(() => ({
    associationsData: {
      primaryAssociationObject: associationsData === null || associationsData === void 0 ? void 0 : associationsData.primaryAssociationObject,
      impliedUnlabeledAssociationObjects: associationsData === null || associationsData === void 0 ? void 0 : associationsData.impliedUnlabeledAssociationObjects,
      associationsDataError: associationsData === null || associationsData === void 0 ? void 0 : associationsData.associationsDataError
    },
    associationTypesData: associationTypesData,
    cardId,
    hasScope,
    isEmbedded,
    isUngated,
    objectId: Number(objectId),
    objectTypeId,
    objectTypePermissions: objectTypePermissions,
    onAssociationUpdate,
    onObjectCreate,
    onObjectUpdate,
    primaryDisplayLabel: primaryDisplayLabel,
    propertyNames,
    propertySource: propertySourceInfo,
    readOnly,
    refetchAssociationsData,
    sortConfiguration,
    toObjectTypeId,
    userPermissions: userPermissions
  }), [associationTypesData, associationsData === null || associationsData === void 0 ? void 0 : associationsData.associationsDataError, associationsData === null || associationsData === void 0 ? void 0 : associationsData.impliedUnlabeledAssociationObjects, associationsData === null || associationsData === void 0 ? void 0 : associationsData.primaryAssociationObject, cardId, hasScope, isEmbedded, isUngated, objectId, objectTypeId, objectTypePermissions, onAssociationUpdate, onObjectCreate, onObjectUpdate, primaryDisplayLabel, propertyNames, propertySourceInfo, readOnly, refetchAssociationsData, sortConfiguration, toObjectTypeId, userPermissions]);
  if (isLoading && (!(associationsData !== null && associationsData !== void 0 && associationsData.impliedUnlabeledAssociationObjects) || !(associationTypesData !== null && associationTypesData !== void 0 && associationTypesData.associationTypes.length))) {
    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsx(ActionSkeleton, {});
  }
  return /*#__PURE__*/_jsx(AssociatedObjectsCardContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(AssociatedObjectsCardActions, {})
  });
}
export default AssociatedObjectsCardActionsSdkDataProvider;